// src/pages/ContentEditor/components/EditorBreadcrumbs.js
import React from 'react';
import { Breadcrumbs, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

const EditorBreadcrumbs = ({ isNewContent, contentId, contentTitle }) => {
  const theme = useTheme();
  
  return (
    <Breadcrumbs 
      aria-label="breadcrumb" 
      sx={{ 
        mb: 2,
        '& .MuiBreadcrumbs-separator': {
          color: theme.palette.text.secondary
        }
      }}
    >
      <Link 
        component={RouterLink} 
        to="/" 
        sx={{ 
          color: theme.palette.text.secondary,
          textDecoration: 'none',
          '&:hover': {
            color: theme.palette.primary.main
          }
        }}
      >
        Dashboard
      </Link>
      {!isNewContent && (
        <Link 
          component={RouterLink} 
          to={`/content/${contentId}`} 
          sx={{ 
            color: theme.palette.text.secondary,
            textDecoration: 'none',
            '&:hover': {
              color: theme.palette.primary.main
            }
          }}
        >
          {contentTitle || 'Content Details'}
        </Link>
      )}
      <Typography color="text.primary">
        {isNewContent ? 'Create New Content' : 'Edit Content'}
      </Typography>
    </Breadcrumbs>
  );
};

export default EditorBreadcrumbs;
